<template>
	<div class="am-contact"
		:class="{ 'is-idle': !init }"
	>
		<form class="am-contact__form form--update" @submit="onSubmit" novalidate>
			<am-icon
				class="am-contact__home"
				name="home"
				size="lg"
			/>

			<header class="am-contact__header">
				<am-text class="am-contact__title" type="subtitle">
					Quero saber mais!
				</am-text>

				<am-text class="am-contact__subtitle" type="subtitle">
					Preencha o formulário e entraremos em contato.
				</am-text>
			</header>

			<am-input-text
				class="am-contact__name"
				label="Seu nome"
				v-model="form.name"
				:valid="validation.name"
			/>

			<am-input-text
				class="am-contact__email"
				label="Seu e-mail"
				type="email"
				v-model="form.email"
				:valid="validation.email"
			/>

			<am-input-text
				class="am-contact__phone"
				label="Telefone"
				type="phone"
				v-model="form.phone"
				:valid="validation.phone"
			/>

			<div class="am-contact__wrapper">
				<am-input-textarea
					class="am-contact__message"
					label="Escreva sua mensagem..."
					v-model="form.message"
				/>

				<am-submit
					class="am-contact__submit"
					:state="state"
					@click="submit"
				/>
			</div>

			<am-text class="am-contact__showroom none--contact" type="button">
				<am-icon name="phone" size="lg" />
				<span>
					Telefone do showroom <br /> 
					<b>{{ showroom }}</b>
					<b> / 83 3578-8400</b>
				</span>
			</am-text>
			
			<div class="am-footer__social none--contact">
				<am-text class="am-footer__label" :dark="false" type="button">
					Nos siga em nossas redes sociais
				</am-text>

				<am-icon name="facebook" :dark="false" size="lg" @click.native="onClick('facebook')" />
				<am-icon name="instagram" :dark="false" size="lg" @click.native="onClick('instagram')" />
				<am-icon name="twitter" :dark="false" size="lg" @click.native="onClick('twitter')" />
				<!-- <am-icon name="linkedin" :dark="true" size="sm" /> -->

			</div>

		</form>
		
		<div class="col--social">
			
			<am-text class="am-contact__showroom" type="button">
				<am-icon name="phone" size="lg" />
				<span>
					Telefone do showroom <br /> 
					<b>{{ showroom }}</b>
					<b> / 83 3578-8400</b>
				</span>
			</am-text>

			<div class="am-footer__social">
				<am-text class="am-footer__label" :dark="false" type="button">
					Nos siga em nossas redes sociais
				</am-text>

				<am-icon name="facebook" :dark="false" size="lg" @click.native="onClick('facebook')" />
				<am-icon name="instagram" :dark="false" size="lg" @click.native="onClick('instagram')" />
				<am-icon name="twitter" :dark="false" size="lg" @click.native="onClick('twitter')" />
				<!-- <am-icon name="linkedin" :dark="true" size="sm" /> -->
			</div>
		</div>

	</div>

</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMIcon from '@/components/atoms/AMIcon'
import AMInputText from '@/components/molecules/AMInputText'
import AMInputTextarea from '@/components/molecules/AMInputTextarea'
import AMSubmit from '@/components/molecules/AMSubmit'

export default {
	components: {
		'am-text': AMText,
		'am-icon': AMIcon,
		'am-input-text': AMInputText,
		'am-input-textarea': AMInputTextarea,
		'am-submit': AMSubmit
	},

	props: {
		init: {
			type: Boolean,
			default: false
		},
		showroom: {
			type: String,
			default: '83 9-1234-5678'
		}
	},

	data: () => ({
		state: 'idle',
		valid: false,
		validation: {
			name: true,
			email: true,
			phone: true
		},
		form: {
			name: null,
			email: null,
			phone: null,
			message: null
		}
	}),

	watch: {
		init(value) {
			if (value)
				this.start()
		}
	},

	mounted() {
		if (this.init)
			this.start()
	},

	methods: {

		onClick(provider){
			if (provider == 'facebook'){
				window.open("https://www.facebook.com/conddasamericas","_blank")
			} else if (provider == 'instagram') {
				window.open("https://www.instagram.com/condominiodasamericas/","_blank")
			} else{
				window.open("https://twitter.com/condasamericas","_blank")
			}
		},

		onSubmit(event) {
			event.preventDefault()
			this.submit()
		},

		submit() {
			// TODO Validate form

			if (this.validate() && this.state != 'loading') {
				this.state = 'loading'
				this.$emit('submit', this.form)

				setTimeout(() => {
					this.state = 'done'
				}, 1500)

				setTimeout(() => {
					this.state = 'idle'
					this.reset()
				}, 3000)
			}
		},

		validate() {
			this.validation.name = this.form.name != '' && this.form.name != null
			this.validation.email = this.form.email != '' && this.form.email != null
			this.validation.phone = this.form.phone != '' && this.form.email != null

			this.valid = this.validation.name &&
				this.validation.email &&
				this.validation.phone

			return this.valid
		},

		reset() {
			this.form.name = null
			this.form.email = null
			this.form.phone = null
			this.form.message = null
		},

		start() {
			// TODO
		}
	}
}
</script>

<style lang="scss">
.am-contact{
	background: $c-beige;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: .3s $easeInOutQuad;
	&__form{
		position: relative;
		padding: 16px 24px;
		width: 440px;
		max-width: 100%;
	}
	&__showroom{
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 19px;
		.am-icon{
			margin-right: 8px;
		}
	}
	&__header{
		padding-right: 90px;
		margin-bottom: 16px;
	}
	&__title{
		margin-bottom: 16px;
	}
	&__subtitle{
		font-size: 22px;
		line-height: 24px;
	}
	&__message{
		margin: 24px 0;
	}
	&__home{
		position: absolute;
		top: 16px;
		right: 24px;
		font-size: 50px;
	}
	&__wrapper{
		position: relative;
	}
	&__submit{
		position: absolute;
		bottom: 8px;
		right: 8px;
	}

	&.is-idle{
		opacity: 0;
	}

	.am-footer__social{
		width: 100%;
		margin: 10px 0 0 0;
		padding-top: 10px;
		text-align: center;
		border-top: 1px solid rgba(#99887F, .4);
		.am-text{
			font-size: 30px;
		}
		.am-icon{
			margin: 10px 10px;
		}
		.icon-twitter:before{
			content: "u";
		}
	}
  .address{
      text-align: center;
  }
	@include grid-media($desktop-grid) {
		.am-contact{
			&__form{
			}
			&__showroom{
				font-size: 30px;
			}
		}
    .address{
      padding-top: 170px;
    }
	}

	@media screen and (max-height: 500px) {
		&__title{
			font-size: 24px;
			margin-top: 8px;
			margin-bottom: 0;
		}
		&__subtitle{
			display: none;
		}
		&__showroom{
			font-size: 16px;
		}
		&__message{
			.am-input-textarea{
				&__field{
					min-height: 120px;
				}
			}
		}
	}
}

@media (min-width: 1400px) {  
	
	.col--social{
		display: none!important;
	}
  .address-mobile{
    padding-top: 35px;
    font-size: 22px;
    line-height: 1.5;
    b{
      margin-bottom: 5px;
    }
  }
}

@media (max-width: 1399.98px) {
	.none--contact{
		display: none!important;
	}
	.form--update{
		width: 45%;
		padding-right: 10%;
		.icon-home{
			display: none;
		}
	}
  .address{
    padding-top: 70px;
  }

}

@media (max-width: 768px) {
	.none--contact{
		display: block!important;
		text-align: center;
	}
	.form--update{
		width: 100%;
		padding: 10px 15px;
		.am-input-textarea__field{
			min-height: 120px!important;
		}
	}
	.col--social{
		display: none!important;
	}

  .address-mobile{
    padding-top: 45px;
    font-size: 18px;
  }

}

@media (max-width: 500px){
	.am-contact{
		.am-footer__social{
			.am-text{
				font-size: 16px;
			}
		}
	}
  .address-mobile{
    padding-top: 35px;
    font-size: 14px;
  }
}

</style>